import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";
import "./inspectorConstraints.scss";

import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import FormListButtonWrapper from "../form/FormListButtonWrapper";
import Icon from "../interface/Icon";
import { popoverOrPortal } from "../portal/popoverOrPortal";
import InspectorConstraintBox from "./InspectorConstraintBox";
import InspectorEditDateConstraintView from "./InspectorEditDateConstraintView";

class InspectorConstraintList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
    this._isChildPopoverOn = false;
    this.toggle = this.toggle.bind(this);
    this.closePopover = this.closePopover.bind(this);
    this.onChildPopover = this.onChildPopover.bind(this);
  }

  onTogglePopover(value) {
    const { onTogglePopover } = this.props;
    if (onTogglePopover) {
      onTogglePopover(value);
    }
  }

  toggle() {
    const { popoverOpen } = this.state;
    if (!this._isChildPopoverOn || !popoverOpen) {
      this.setState({
        popoverOpen: !popoverOpen
      });
      this.onTogglePopover(!popoverOpen);
    }
  }

  closePopover() {
    if (!this._isChildPopoverOn) {
      this.setState({
        popoverOpen: false
      });
      this.onTogglePopover(false);
    }
  }

  onChildPopover(value) {
    this._isChildPopoverOn = value;
  }

  renderPopover() {
    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `inspectorPopover`,
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target: "dateConstraintAdd",
      toggle: () => {}
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggle}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>
          <InspectorEditDateConstraintView
            calendar={this.props.calendar}
            constraintDependencyOptions={this.props.constraintDependencyOptions}
            onAddDateConstraint={this.props.onAddDateConstraint}
            onAddRelativeConstraint={this.props.onAddRelativeConstraint}
            onAddDatePartConstraint={this.props.onAddDatePartConstraint}
            closePopover={this.closePopover}
            onChildPopover={this.onChildPopover}
            title={this.props.title}
            backText={this.props.backText}
          />
        </PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return (
      <div className="inspectorConstraintsList">
        {this.props.constraints.map(c => (
          <InspectorConstraintBox
            key={c.ids.size ? c.ids.first() : null}
            constraint={c}
            onStatusClick={() => (this.props.onStatusClick ? this.props.onStatusClick(c.ids) : null)}
            onEditClick={() => this.onEditClick(c)}
            onDeleteClick={() => (this.props.onDeleteClick ? this.props.onDeleteClick(c.ids) : null)}
            onItemClick={this.props.onItemClick}
            title="Date Constraint"
            calendar={this.props.calendar}
            constraintDependencyOptions={this.props.constraintDependencyOptions}
            onAddDateConstraint={this.props.onAddDateConstraint}
            onAddRelativeConstraint={this.props.onAddRelativeConstraint}
            onAddDatePartConstraint={this.props.onAddDatePartConstraint}
            onChooseResolution={this.props.onResolveConstraintUsingOption}
          />
        ))}
        <div id="dateConstraintAdd">
          <FormListButtonWrapper className="dateConstraintAddWrapper" onClick={this.toggle}>
            <Icon
              className="addConstraint"
              icon="listAdd"
              color="iconMono"
              pulse={this.props.pulsateIconId && this.props.pulsateIconId === this.props.addInterfaceIdentifier}
            />
          </FormListButtonWrapper>
        </div>
        {this.state.popoverOpen ? <div className="formListBackdrop" onClick={this.toggle} /> : null}
        {this.state.popoverOpen ? this.renderPopover() : null}
      </div>
    );
  }
}

InspectorConstraintList.propTypes = {
  constraints: PropTypeShapes.inspectorConstraintsList.isRequired,
  constraintDependencyOptions: PropTypeShapes.listOptionList,
  calendar: PropTypeShapes.calendar.isRequired,
  onStatusClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onItemClick: PropTypes.func,
  onAddDateConstraint: PropTypes.func,
  onAddRelativeConstraint: PropTypes.func,
  onAddDatePartConstraint: PropTypes.func,
  onResolveConstraintUsingOption: PropTypes.func,
  onTogglePopover: PropTypes.func,
  title: PropTypes.string,
  backText: PropTypes.string,

  addInterfaceIdentifier: PropTypes.string,
  pulsateIconId: PropTypes.string,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = InspectorConstraintList;
//#!if iOS === true
// exportedView = withScreenContext(InspectorConstraintList);
//#!endif
export default exportedView;
